export default "/images/chevron-right.svg?3226daed6aea78e7fd41acb192f53d19";